<div>
    <table class="forecast-create-missing-table">
        <tr>
            <td>
                <label style="margin-bottom: 0;">Missing Parcel {{ taxYear }} Tax Years:</label>
            </td>
            <td></td>
            <td>
                {{ numMissingTaxYears }}
            </td>
            <td></td>
            <td>
                @if (editMode) {
                    <button [disabled]="!isMissingCreateAllowed()"
                            class="ace-btn btn-sm btn-primary"
                            (click)="createMissing()">
                        Create
                    </button>
                }
            </td>
        </tr>
    </table>
</div>
